import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Avatar,
} from '@mui/material';

import CampaignIcon from '@mui/icons-material/Campaign';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoIcon from '@mui/icons-material/Info';
import CelebrationIcon from '@mui/icons-material/Celebration';

import Breadcrumb from './BreadCrump';
import TopNav from './Navbar';
import LeftNavbar from './LeftNav';

// Icon mapping based on string keys from backend
const iconMap = {
  InfoIcon: <InfoIcon />,
  AccessTimeIcon: <AccessTimeIcon />,
  CelebrationIcon: <CelebrationIcon />,
};

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const res = await fetch('http://196.216.9.34:5020/api/announcements');
        const data = await res.json();
        setAnnouncements(data);
      } catch (err) {
        console.error('Failed to fetch announcements:', err);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Left Navigation */}
      <LeftNavbar />

      {/* Main content wrapper */}
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        {/* Top Navigation */}
        <TopNav />

        {/* Content */}
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Announcements" />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: '#ff6600', mb: 4 }}
          >
            <CampaignIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Announcements
          </Typography>

          <Stack spacing={3}>
            {announcements.map((item) => (
              <Card
                key={item.id}
                sx={{ borderLeft: '6px solid #ff6600', boxShadow: 2 }}
              >
                <CardContent>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    mb={1}
                  >
                    <Avatar sx={{ bgcolor: '#ff6600' }}>
                      {iconMap[item.icon] || <InfoIcon />}
                    </Avatar>
                    <Typography variant="h6" fontWeight="600">
                      {item.title}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1.5 }}
                  >
                    {item.description}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#666',
                    }}
                  >
                    <AccessTimeIcon sx={{ fontSize: 16, mr: 0.5 }} />
                    {item.timestamp}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Announcements;
